import React from "react";
import { resolveRisk, RISK_BY_KEY } from "../lib/risk";

/**
 * Compact RAG badge — a coloured dot + label.
 * Usage: <RiskBadge value={project.risk_status} />
 */
export default function RiskBadge({ value, size = "sm", showLabel = true, testId }) {
  const key = resolveRisk(value);
  const meta = RISK_BY_KEY[key];
  const dot = size === "xs" ? 6 : 8;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded font-medium ${
        size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5"
      }`}
      style={{ background: `${meta.tone}18`, color: meta.tone }}
      data-testid={testId || `risk-badge-${key}`}
      aria-label={`Risk ${meta.label}`}
    >
      <span
        style={{
          width: dot,
          height: dot,
          background: meta.tone,
          borderRadius: "50%",
          display: "inline-block",
        }}
      />
      {showLabel && meta.label}
    </span>
  );
}
